import React from 'react'
import VacationsComponents from '../../Layout/Vacations'

const VacationsPage = () => {
  return <VacationsComponents />
}

export default VacationsPage
